import PropTypes from 'prop-types';
import CsvUploader from '../FleetsSection/CsvUploader';
import { csvUploaderConfig } from '../FleetsSection/FleetsSection';
import { useTranslation } from 'react-i18next';

const { Typography, Button } = require('@mui/material');
const { Box } = require('@mui/system');

function VehicleUploadSelection({
  vehicleType,
  setVehicleType,
  provisionedVehicleTypes,
}) {
  const { t } = useTranslation();
  return (
    <>
      {!vehicleType ? (
        <Box width={'20rem'}>
          <Typography variant='h6' sx={{ marginTop: '24px' }}>
            {t('homePage.vehicleType')}
          </Typography>
          <Box
            display='flex'
            justifyContent='flex-start'
            flexWrap={'wrap'}
            gap={'20px'}
            marginTop={'24px'}
          >
            {provisionedVehicleTypes?.map(vType => (
              <Button
                key={vType}
                variant='contained'
                color='primary'
                disableElevation
                style={{
                  textTransform: 'capitalize',
                  // opacity: axleName !== item && axleName !== null ? 0.5 : 1,
                }}
                onClick={() => {
                  if (vehicleType === vType) {
                    setVehicleType(null);
                  } else {
                    setVehicleType(vType);
                  }
                }}
                disabled={vehicleType !== vType && vehicleType !== null}
                data-hook={vType}
              >
                {vType}
              </Button>
            ))}
          </Box>
        </Box>
      ) : (
        <CsvUploader
          title={csvUploaderConfig[vehicleType]['title']}
          headers={csvUploaderConfig[vehicleType]['headers']}
          asset_type={csvUploaderConfig[vehicleType]['asset_type']}
          header1={csvUploaderConfig[vehicleType]['header1']}
          header2={csvUploaderConfig[vehicleType]['header2']}
          flex_direction='column'
        />
      )}
    </>
  );
}

export default VehicleUploadSelection;

// Add 'setVehicleType' to props validation
VehicleUploadSelection.propTypes = {
  vehicleType: PropTypes.string,
  setVehicleType: PropTypes.func.isRequired,
  provisionedVehicleTypes: PropTypes.array,
};
